var _defs, _polyline, _polyline2, _polyline3, _line, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew321({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "15.77 6.11 12.06 9.82 8.35 6.11"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "15.77 4.25 12.06 7.96 8.35 4.25"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "15.77 2.4 12.06 6.11 8.35 2.4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 12.06,
    y1: 5.91,
    x2: 12.06,
    y2: 13.73
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.23,5.49l1-3.22h.37L2.7,5.49H2.3l-.3-1H.89l-.29,1ZM1,4.17h.9l-.28-.89c-.08-.28-.14-.5-.18-.67,0,.21-.09.41-.15.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.69,5.49l1-3.22h.37L5.17,5.49h-.4l-.31-1H3.35l-.29,1Zm.76-1.32h.9l-.28-.89C4,3,3.93,2.78,3.89,2.61a4.66,4.66,0,0,1-.15.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.93,5.49l-1-3.22h.38L6,4.61c0,.18.1.36.14.53,0-.18.09-.35.14-.53L7,2.27h.35l-1,3.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew321);
export default __webpack_public_path__ + "static/media/Symbolpack_New_321.c1dae88ae8c1e6c0ea2a7ac22cd62413.svg";
export { ForwardRef as ReactComponent };